import React from 'react';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import Icon from '@components/common/atoms/Icon';

export interface MuiAlertProps {
  severity: 'success' | 'error';
  children: React.ReactNode;
  onDismiss?: () => void;
}

/**
 * MUI-first sibling of the inline success/error banner markup that used
 * to live directly in LoginPage.tsx — same look (icon, message, optional
 * dismiss), now a reusable component.
 */
export const MuiAlert: React.FC<MuiAlertProps> = ({ severity, children, onDismiss }) => (
  <Alert
    severity={severity}
    icon={<Icon name={severity === 'success' ? 'CheckCircle' : 'XCircle'} size={18} />}
    action={
      onDismiss ? (
        <IconButton size="small" onClick={onDismiss} color="inherit">
          <Icon name="X" size={16} />
        </IconButton>
      ) : undefined
    }
    sx={{
      borderRadius: '12px', // rounded-xl
      border: '2px solid',
      borderColor: severity === 'success' ? 'success.light' : 'error.light',
      fontWeight: severity === 'error' ? 600 : 400,
      alignItems: 'center',
    }}
  >
    {children}
  </Alert>
);

export default MuiAlert;
